import React, {useEffect, useState} from "react";
import SimpleLineIcon from "react-simple-line-icons";
import "./Verify.scss";
import {useLocation,useHistory} from "react-router";
import {fixNumbers, MessageHandler, Setup, Validation, VerifyRequest} from "../../Services";
import {isMobile} from "react-device-detect";
import ReactGA from 'react-ga';
import {useDispatchUser, useUser,useDispatchMall} from "../../hooks";
import {MallsData} from "../Malls/MallsServices";
import {CheckinData} from "../Scan/ScanServices";
import toaster from "toasted-notes";


function Error(props) {

    return(
        <div className="error_message-container">
            <span className="text-message">{props.message}</span>
        </div>
    )
}

function Verify() {

    //hooks
    const location = useLocation();
    const history = useHistory();
    const setUser = useDispatchUser();
    const setMall = useDispatchMall();


    // states
    const [code,setCode] = useState("");
    const [token,setToken] = useState("");
    const [verifyState,setVerifyState] = useState(false);
    const [btnState,setBtnState] = useState(true);



    useEffect(()=>{
        if(location.state && location.state.token){
            setToken(location.state.token)
            // clear history state
            history.replace('/verify',{...location.state,token:""});
        }
    },[])





    // Login Method -------------------------------------------------------------------
    const Verify_Request = async () => {
        if(verifyState){return}

        // pre request
        setVerifyState(true);



        if (!Validation({type:"VERIFY_TOKEN",val:fixNumbers(code)})){
            MessageHandler({type:"VALIDATION",status:"VERIFY_CODE"})
            setVerifyState(false);
            return ;
        }

        if (token.length<1){
            MessageHandler({type:"VALIDATION",status:"VERIFY_TOKEN"})
            setVerifyState(false);
            return ;
        }

        // console.log("DDDD2 : ")

        //request
        try{

            let response = await VerifyRequest({code:fixNumbers(code),token:token})
            //post success request
            setVerifyState(false);
            //MessageHandler({type:"LOGIN",status:"SUCCESS"})

            //set Token to localstorage
            localStorage.setItem('token',response.data.access_token);
            // localStorage.setItem('merchantId',Setup.default_merchant);

            //User Set
            localStorage.setItem('user',JSON.stringify(response.data));
            setUser(response.data);
            //set User GA
            // ReactGA.initialize('UA-175496552-1', {
            //     debug: false,
            //     titleCase: false,
            //     gaOptions: {
            //         userId: 123,
            //         clientId: response.data.phone
            //     }
            // });
            //ReactGA.set({userId:response.data.phone})


            //set Malls

            //first Mall
           try{
               if(!location.state.mall){
                   let malls = await MallsData();
                   //let malls = {data:[]}
                   // console.log("DATA 0 ",malls)
                   if(malls.data.length<1){
                       localStorage.removeItem('mallId');
                       localStorage.removeItem('merchants');
                       localStorage.removeItem('mallLogo');
                       localStorage.removeItem('mallName');
                       localStorage.removeItem('mall');
                       localStorage.removeItem('user');
                       localStorage.removeItem('cats');
                       localStorage.removeItem('wait');
                       localStorage.removeItem('token');
                       localStorage.removeItem('allowNotif');
                       // console.log("DATA 1 ")
                       toaster.notify(({ onClose }) => (<Error   message={"محتوایی برای نمایش وجود ندارد"}/>),{duration: 2000});
                       setTimeout(()=>{
                           history.push('/login');
                       },3000)

                   }else {
                       localStorage.setItem('mallId',malls.data[0].uid);
                       localStorage.setItem('mallLogo',malls.data[0].header_image);
                       localStorage.setItem('mallName',malls.data[0].name);
                       localStorage.setItem('mall',JSON.stringify(malls.data[0]));
                       setMall(malls.data[0]);
                       // console.log("DATA 2 ")
                       history.push('/merchants')
                   }

               }else {
                   // console.log("/Malllllllll",location.state.mall)
                   let malli = location.state.mall;
                   await CheckinData("mc_"+malli.uid)
                   localStorage.setItem('mallId',malli.uid);
                   localStorage.setItem('mallLogo',malli.header_image);
                   localStorage.setItem('mallName',malli.name);
                   localStorage.setItem('mall',JSON.stringify(malli));
                   setMall(malli);
                   // console.log("DATA 3 ")
                   history.push('/merchants')
               }
           }catch (e) {
               // console.log("DATA 4 ")
               // console.log(e)
           }


        }catch (e) {
            // console.log(e)
            //post failed request
            setVerifyState(false);
            MessageHandler({type:"VALIDATION",status:"VERIFY_TOKEN"})
        }
    }

    const updateWindowDimensions = () => {
        if(window.innerHeight<380){
            setBtnState(false)
        }else {
            setBtnState(true)
        }
    }

    useEffect(()=>{
        window.addEventListener('resize',updateWindowDimensions);
        return () => {window.addEventListener('resize',updateWindowDimensions)}
    },[])

    const onEnter = (event, callback) => event.key  === 'Enter' && callback()
    const enterEvent = () => Verify_Request();

    return(
        <div className="otp-container">

            <div className="otp-logo">
                <img src="/other/logo.png" alt="Digi Mall"/>
            </div>

            <div className="otp-message">
                <div className="otp-message">
                    <span>را وارد کنید</span>
                    {/*<span>{location.state && location.state.mobile}</span>*/}
                    <span>لطفا کد فعالسازی ارسال شده </span>
                </div>
            </div>

            <div className="otp-input">
                <input
                    value={code}
                    onFocus={()=>{if(isMobile){setBtnState(false)}}}
                    onBlur={()=>{setTimeout(()=>{setBtnState(true)},100)}}
                    onChange={(e)=>{setCode(e.target.value)}}
                    onKeyPress={e => onEnter(e, enterEvent)}
                    type="text" name="" id="" placeholder="کد فعال سازی ۴ رقمی"/>
                <SimpleLineIcon name="lock"/>
            </div>


            {btnState?<div className="top-float-send-btn">
                <div className="float-btn" onClick={Verify_Request}>
                    {verifyState?<i className="fa fa-spinner fa-spin"></i>:<i className="fa fa-arrow-left"></i>}
                    ورود
                    <span style={{fontSize:17}}></span>
                </div>
            </div>:null}

        </div>
    )
}

export {Verify}
